module.exports = __webpack_public_path__ + "img/logo_text.bfc03ffc.png";